$(document).ready(function(){
    gsap.registerPlugin(ScrollTrigger);
    $('.container-area-showcase').each(function(){
        var id = $(this).attr('id');
        console.log(id)
        gsap.from('#'+id+' .block__row-item',{
            opacity:0,
            y:100,
            duration:1,
            ease: 'back',
            scrollTrigger: '#'+id,
            stagger:{
                each: 0.2
            }
        })
    })
    
})